import Vue from 'vue'
import Vuex from 'vuex'


import auth from './modules/auth'
import testusers from './modules/testusers'
Vue.use(Vuex)



export default new Vuex.Store({
	modules: {
		auth,
		testusers
	},
	strict: true
})